import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.EftFundResponse,
  EftFund: (params: vp.EftFundRequest) => void,
  reset: () => void,
  EftFundAsync: (params: vp.EftFundRequest) => Promise<vp.EftFundResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostEftFund: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldEftFund, setShouldEftFund] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.EftFundRequest>({
    PortalUser: '',
    CompanyName: '',
    FirstName: '',
    LastName: '',
    DOB: '',
    PhoneNumber: '',
    Address1: '',
    Address2: '',
    City: '',
    Province: '',
    Country: '',
    PostalCode: '',
    Token: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    Amount: 0,
    Currency: '',
    ClientReferenceNumber: '',
    Notes: '',
    ClientAccountID: '',
    FlinksAccountID: '',
    FlinksLoginID: '',
    institution: '',
    KYCPerformed: false,
    DelayBankingInfo: false,
    TransactionLabel: '',
    KYCReferenceNumber: '',
  });
  const [response, setResponse] = useState<vp.EftFundResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    Flagged: '',
    Iq11: false,
  });

  useEffect(() => {
    if (!shouldEftFund) return () => {};

    const PostEftFund = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postEftFund(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEftFund) void PostEftFund();
    setShouldEftFund(false);
    return () => {
      source.cancel();
    };
  }, [shouldEftFund]);

  return [
    response,
    (_params: vp.EftFundRequest) => {
      setParams(_params);
      setShouldEftFund(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        Flagged: '',
        Iq11: false,
      });
      setShouldEftFund(false);
    },
    async (params: vp.EftFundRequest) => {
      return api.postEftFund(params, source);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostEftFund);
